// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","611":"roadmap"}[chunkId] || chunkId) + "-legacy." + {"56":"694f51eb","58":"d88f0a1c","409":"716a7bae","443":"44ea3e4c","598":"8d1f221c","611":"911864bf","703":"31647ff7","849":"ba837d1d","927":"ce5ee293"}[chunkId] + ".js";
};